import { createFileRoute } from '@tanstack/react-router'

import { AccountDetailsLayout } from '@/containers/accountDetailsLayout'

export const Route = createFileRoute('/_authenticated/account/_accountDetails')(
  {
    component: AccountDetailsLayout,
    beforeLoad: () => ({
      breadCrumbTitle: 'Account',
    }),
  }
)
